/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  AuthorizeShopifyBody,
  CreateOrderIntegrationBody,
  Error,
  GetOrderIntegrations200,
  GetOrderIntegrationsParams,
  OrderIntegration,
  ShopifyAuthorizeResponse,
  SyncShopifyOrdersBody,
  SyncShopifyOrdersResponse,
  UpdateOrderIntegrationBody,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Generate a Shopify OAuth authorization URL. Redirect the user to this URL to authorize the Shopify connection.
 * @summary Start Shopify OAuth flow
 */
export type authorizeShopifyResponse200 = {
  data: ShopifyAuthorizeResponse
  status: 200
}

export type authorizeShopifyResponse400 = {
  data: Error
  status: 400
}

export type authorizeShopifyResponse401 = {
  data: Error
  status: 401
}

export type authorizeShopifyResponse403 = {
  data: Error
  status: 403
}

export type authorizeShopifyResponse404 = {
  data: Error
  status: 404
}

export type authorizeShopifyResponse422 = {
  data: ValidationError
  status: 422
}

export type authorizeShopifyResponse500 = {
  data: Error
  status: 500
}

export type authorizeShopifyResponseSuccess = (authorizeShopifyResponse200) & {
  headers: Headers;
};
export type authorizeShopifyResponseError = (authorizeShopifyResponse400 | authorizeShopifyResponse401 | authorizeShopifyResponse403 | authorizeShopifyResponse404 | authorizeShopifyResponse422 | authorizeShopifyResponse500) & {
  headers: Headers;
};

export type authorizeShopifyResponse = (authorizeShopifyResponseSuccess | authorizeShopifyResponseError)

export const getAuthorizeShopifyUrl = () => {


  

  return `/order-integrations/shopify/authorize`
}

export const authorizeShopify = async (authorizeShopifyBody: AuthorizeShopifyBody, options?: RequestInit): Promise<authorizeShopifyResponse> => {
  
  return customFetch<authorizeShopifyResponse>(getAuthorizeShopifyUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      authorizeShopifyBody,)
  }
);}
  

/**
 * Fetch Shopify orders updated in the selected time window and upsert them into local orders. Missing orders are imported, existing orders are refreshed, and processing is queued separately.
 * @summary Sync Shopify orders
 */
export type syncShopifyOrdersResponse200 = {
  data: SyncShopifyOrdersResponse
  status: 200
}

export type syncShopifyOrdersResponse400 = {
  data: Error
  status: 400
}

export type syncShopifyOrdersResponse401 = {
  data: Error
  status: 401
}

export type syncShopifyOrdersResponse403 = {
  data: Error
  status: 403
}

export type syncShopifyOrdersResponse404 = {
  data: Error
  status: 404
}

export type syncShopifyOrdersResponse422 = {
  data: ValidationError
  status: 422
}

export type syncShopifyOrdersResponse500 = {
  data: Error
  status: 500
}

export type syncShopifyOrdersResponseSuccess = (syncShopifyOrdersResponse200) & {
  headers: Headers;
};
export type syncShopifyOrdersResponseError = (syncShopifyOrdersResponse400 | syncShopifyOrdersResponse401 | syncShopifyOrdersResponse403 | syncShopifyOrdersResponse404 | syncShopifyOrdersResponse422 | syncShopifyOrdersResponse500) & {
  headers: Headers;
};

export type syncShopifyOrdersResponse = (syncShopifyOrdersResponseSuccess | syncShopifyOrdersResponseError)

export const getSyncShopifyOrdersUrl = (id: string,) => {


  

  return `/order-integrations/${id}/sync-shopify`
}

export const syncShopifyOrders = async (id: string,
    syncShopifyOrdersBody?: SyncShopifyOrdersBody, options?: RequestInit): Promise<syncShopifyOrdersResponse> => {
  
  return customFetch<syncShopifyOrdersResponse>(getSyncShopifyOrdersUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      syncShopifyOrdersBody,)
  }
);}
  

/**
 * Create a new order integration for receiving orders from external platforms.
 * @summary Create a new order integration
 */
export type createOrderIntegrationResponse201 = {
  data: OrderIntegration
  status: 201
}

export type createOrderIntegrationResponse400 = {
  data: Error
  status: 400
}

export type createOrderIntegrationResponse401 = {
  data: Error
  status: 401
}

export type createOrderIntegrationResponse403 = {
  data: Error
  status: 403
}

export type createOrderIntegrationResponse404 = {
  data: Error
  status: 404
}

export type createOrderIntegrationResponse422 = {
  data: ValidationError
  status: 422
}

export type createOrderIntegrationResponse500 = {
  data: Error
  status: 500
}

export type createOrderIntegrationResponseSuccess = (createOrderIntegrationResponse201) & {
  headers: Headers;
};
export type createOrderIntegrationResponseError = (createOrderIntegrationResponse400 | createOrderIntegrationResponse401 | createOrderIntegrationResponse403 | createOrderIntegrationResponse404 | createOrderIntegrationResponse422 | createOrderIntegrationResponse500) & {
  headers: Headers;
};

export type createOrderIntegrationResponse = (createOrderIntegrationResponseSuccess | createOrderIntegrationResponseError)

export const getCreateOrderIntegrationUrl = () => {


  

  return `/order-integrations`
}

export const createOrderIntegration = async (createOrderIntegrationBody: CreateOrderIntegrationBody, options?: RequestInit): Promise<createOrderIntegrationResponse> => {
  
  return customFetch<createOrderIntegrationResponse>(getCreateOrderIntegrationUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createOrderIntegrationBody,)
  }
);}
  

/**
 * Retrieve a paginated list of order integrations with optional filtering and sorting.
 * @summary List all order integrations
 */
export type getOrderIntegrationsResponse200 = {
  data: GetOrderIntegrations200
  status: 200
}

export type getOrderIntegrationsResponse400 = {
  data: Error
  status: 400
}

export type getOrderIntegrationsResponse401 = {
  data: Error
  status: 401
}

export type getOrderIntegrationsResponse403 = {
  data: Error
  status: 403
}

export type getOrderIntegrationsResponse404 = {
  data: Error
  status: 404
}

export type getOrderIntegrationsResponse500 = {
  data: Error
  status: 500
}

export type getOrderIntegrationsResponseSuccess = (getOrderIntegrationsResponse200) & {
  headers: Headers;
};
export type getOrderIntegrationsResponseError = (getOrderIntegrationsResponse400 | getOrderIntegrationsResponse401 | getOrderIntegrationsResponse403 | getOrderIntegrationsResponse404 | getOrderIntegrationsResponse500) & {
  headers: Headers;
};

export type getOrderIntegrationsResponse = (getOrderIntegrationsResponseSuccess | getOrderIntegrationsResponseError)

export const getGetOrderIntegrationsUrl = (params?: GetOrderIntegrationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/order-integrations?${stringifiedParams}` : `/order-integrations`
}

export const getOrderIntegrations = async (params?: GetOrderIntegrationsParams, options?: RequestInit): Promise<getOrderIntegrationsResponse> => {
  
  return customFetch<getOrderIntegrationsResponse>(getGetOrderIntegrationsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retrieve a single order integration by its unique identifier.
 * @summary Get order integration by ID
 */
export type getOrderIntegrationByIdResponse200 = {
  data: OrderIntegration
  status: 200
}

export type getOrderIntegrationByIdResponse401 = {
  data: Error
  status: 401
}

export type getOrderIntegrationByIdResponse403 = {
  data: Error
  status: 403
}

export type getOrderIntegrationByIdResponse404 = {
  data: Error
  status: 404
}

export type getOrderIntegrationByIdResponse500 = {
  data: Error
  status: 500
}

export type getOrderIntegrationByIdResponseSuccess = (getOrderIntegrationByIdResponse200) & {
  headers: Headers;
};
export type getOrderIntegrationByIdResponseError = (getOrderIntegrationByIdResponse401 | getOrderIntegrationByIdResponse403 | getOrderIntegrationByIdResponse404 | getOrderIntegrationByIdResponse500) & {
  headers: Headers;
};

export type getOrderIntegrationByIdResponse = (getOrderIntegrationByIdResponseSuccess | getOrderIntegrationByIdResponseError)

export const getGetOrderIntegrationByIdUrl = (id: string,) => {


  

  return `/order-integrations/${id}`
}

export const getOrderIntegrationById = async (id: string, options?: RequestInit): Promise<getOrderIntegrationByIdResponse> => {
  
  return customFetch<getOrderIntegrationByIdResponse>(getGetOrderIntegrationByIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Update an existing order integration. Only the provided fields will be updated.
 * @summary Update an order integration
 */
export type updateOrderIntegrationResponse200 = {
  data: OrderIntegration
  status: 200
}

export type updateOrderIntegrationResponse400 = {
  data: Error
  status: 400
}

export type updateOrderIntegrationResponse401 = {
  data: Error
  status: 401
}

export type updateOrderIntegrationResponse403 = {
  data: Error
  status: 403
}

export type updateOrderIntegrationResponse404 = {
  data: Error
  status: 404
}

export type updateOrderIntegrationResponse422 = {
  data: ValidationError
  status: 422
}

export type updateOrderIntegrationResponse500 = {
  data: Error
  status: 500
}

export type updateOrderIntegrationResponseSuccess = (updateOrderIntegrationResponse200) & {
  headers: Headers;
};
export type updateOrderIntegrationResponseError = (updateOrderIntegrationResponse400 | updateOrderIntegrationResponse401 | updateOrderIntegrationResponse403 | updateOrderIntegrationResponse404 | updateOrderIntegrationResponse422 | updateOrderIntegrationResponse500) & {
  headers: Headers;
};

export type updateOrderIntegrationResponse = (updateOrderIntegrationResponseSuccess | updateOrderIntegrationResponseError)

export const getUpdateOrderIntegrationUrl = (id: string,) => {


  

  return `/order-integrations/${id}`
}

export const updateOrderIntegration = async (id: string,
    updateOrderIntegrationBody: UpdateOrderIntegrationBody, options?: RequestInit): Promise<updateOrderIntegrationResponse> => {
  
  return customFetch<updateOrderIntegrationResponse>(getUpdateOrderIntegrationUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateOrderIntegrationBody,)
  }
);}
  

/**
 * Soft delete an order integration. If Shopify, webhooks will be unregistered (best effort).
 * @summary Delete an order integration
 */
export type deleteOrderIntegrationResponse204 = {
  data: void
  status: 204
}

export type deleteOrderIntegrationResponse400 = {
  data: Error
  status: 400
}

export type deleteOrderIntegrationResponse401 = {
  data: Error
  status: 401
}

export type deleteOrderIntegrationResponse403 = {
  data: Error
  status: 403
}

export type deleteOrderIntegrationResponse404 = {
  data: Error
  status: 404
}

export type deleteOrderIntegrationResponse422 = {
  data: ValidationError
  status: 422
}

export type deleteOrderIntegrationResponse500 = {
  data: Error
  status: 500
}

export type deleteOrderIntegrationResponseSuccess = (deleteOrderIntegrationResponse204) & {
  headers: Headers;
};
export type deleteOrderIntegrationResponseError = (deleteOrderIntegrationResponse400 | deleteOrderIntegrationResponse401 | deleteOrderIntegrationResponse403 | deleteOrderIntegrationResponse404 | deleteOrderIntegrationResponse422 | deleteOrderIntegrationResponse500) & {
  headers: Headers;
};

export type deleteOrderIntegrationResponse = (deleteOrderIntegrationResponseSuccess | deleteOrderIntegrationResponseError)

export const getDeleteOrderIntegrationUrl = (id: string,) => {


  

  return `/order-integrations/${id}`
}

export const deleteOrderIntegration = async (id: string, options?: RequestInit): Promise<deleteOrderIntegrationResponse> => {
  
  return customFetch<deleteOrderIntegrationResponse>(getDeleteOrderIntegrationUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

